import {
  GetBusinessInfoResponse,
  MyBusiness,
} from "@1games-ru/region-shared/dist/backend/requests/business";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import useAppSelector from "@/core/helpers/useAppSelector";
import Loader from "@/shared/ui/Loader";
import DeviceTabContentWrapper from "@/shared/widgets/DeviceTabContentWrapper";
import { pricesForServicesSelector } from "@/domains/business/slice";
import { getBusinessCardImage } from "@/domains/business/helpers/getBusinessImage";
import useGetPriceForServicesData from "@/domains/business/hooks/useGetPriceForServicesData";
import BusinessPricesForServicessServiceCardContainer from "@/domains/business/containers/tablet/tabs/pricesForServices/BusinessPricessForServicesCardContainer";

type Props = {
  info: MyBusiness | GetBusinessInfoResponse;
  onClose: () => void;
};

export default function BusinessPricesForServicesContainer({ info, onClose }: Props) {
  const { t } = useTranslation("business");
  const servicesList = useAppSelector(pricesForServicesSelector, shallowEqual);

  const { setExtraCharge, isUpdating, isFirstLoading } = useGetPriceForServicesData(info?.id);

  const header = t("business.pricesForServices.title");
  const footer = !isFirstLoading ? (
    <div className="relative mt-5">
      <div className="absolute z-2 left-0 -top-11 w-full h-6 bg-gradient-to-t from-dark-900 to-transparent" />
      <p className="text-15 font-medium text-white/20">
        {t("business.pricesForServices.changeDescription")}
      </p>
    </div>
  ) : null;

  return (
    <DeviceTabContentWrapper header={header} footer={footer} onClose={onClose}>
      {isFirstLoading ? (
        <Loader />
      ) : (
        <div className="grid grid-cols-3 gap-1.5 w-full">
          {servicesList?.length > 0 &&
            servicesList.map((item) => (
              <BusinessPricesForServicessServiceCardContainer
                key={item.id}
                src={getBusinessCardImage(item?.templateId, "products")}
                item={item}
                setExtraCharge={setExtraCharge}
                isUpdating={isUpdating}
              />
            ))}
        </div>
      )}
    </DeviceTabContentWrapper>
  );
}
